<ng-container *ngIf="desktop | async" i18n>
  <div class="section_7">
    <div class="section_7-img">
      <img ngOptimizedImage [ngSrc]="'../assets/images/Death_to_stock_cycling_in_Seattle_6_large 1.webp'" [fill]="true" alt="">
    </div>
    <div class="section_7-content">
      <div>
        <div class="section-header">
          We want to keep you traveling
        </div>
        <div class="section-content">
          Hostel Hop was built by travelers who have lived and worked in hostels for more than a decade. We know what is important to serious backpackers, and we prioritize features that promote the lifestyle you seek.
        </div>
      </div>
      <div class="button-wrapper">
        <a class="btn btn-frame btn-large btn-icon sign-in-btn" (click)="login()" target="_blank">
          <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/backpack_2.svg"></svg-icon>
          <span>Sign up with Hostel Hop</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!(desktop | async)" i18n>
  <div class="section_7-sm">
    <div class="section_7-img">
      <img ngOptimizedImage [ngSrc]="'../assets/images/Death_to_stock_cycling_in_Seattle_6_large 1.webp'" [fill]="true" alt="">
    </div>
    <div class="section_7-content">
      <div>
        <div class="section-header">
          We want to keep you traveling
        </div>
        <div class="section-content">
          Hostel Hop was built by travelers who have lived and worked in hostels for more than a decade. We know what is important to serious backpackers, and we prioritize features that promote the lifestyle you seek.
        </div>
      </div>
      <div class="button-wrapper">
        <a class="btn btn-frame btn-large btn-icon sign-in-btn" (click)="login()" target="_blank">
          <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/backpack_2.svg"></svg-icon>
          <span>Sign up with Hostel Hop</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>
